<template>
  <div class="page-home">
    <vue-headful
      title="Itchyfeet - Home"
      description="Itchyfeet"
    />
    <header class="container-fluid">
      <div class="overlay"></div>
      <video playsinline="playsinline" autoplay="autoplay" muted="muted" loop="loop">
        <source src="/static/bg_video.mp4" type="video/mp4">
      </video>
      <div class="container h-100 text-center">
        <div class="d-flex text-center h-100">
          <div class="my-auto w-100">
            <transition name="fade1"><span class="h1" v-if="show1">a travel app</span></transition>
            <br>
            <transition name="fade1"><span class="h1" v-if="show2">that's social</span></transition>
            <br v-if="!show2" />
            <br v-if="!show2" />

            <transition name="fade1">
              <p v-if="show4" class="lead"><span class="waiting-list-count">{{Math.floor(waitingListCountTween + 1000)}}</span> people have requested early access, make sure you get yours below!</p>
            </transition>

            <transition name="fade1">
              <div class="form-inline justify-content-center request-invite" v-if="show4">
                <div class="form-group mr-1">
                  <input type="email" class="form-control form-control-lg pl-4" placeholder="Your email" v-bind:value="email" v-on:keyup.enter="onRequestInviteClicked" v-on:change="onEmailUpdatedEvent"/>
                </div>

                <a class="btn btn-lg btn-primary" v-on:click="onRequestInviteClicked">Get early access</a>
              </div>
            </transition>
          </div>
        </div>
      </div>

      <transition name="fade1">
        <div v-if="show4" class="store-icon-wrapper">
          <div class="store-icons">
            <img src="/static/store-icons.png" />
          </div>
        </div>
      </transition>

      <transition name="fade1">
        <div v-if="show4" class="store-icon-wrapper d-none d-md-block">
          <a class="bottom-right-arrow">
            <font-awesome-icon icon="arrow-circle-down" size="3x"></font-awesome-icon>
          </a>
        </div>
      </transition>
    </header>

    <section class="section-1 container-fluid">
      <div class="container h-100">
        <div class="d-flex text-center h-100 justify-content-center">
          <div class="my-auto">
            <h1>you're here too?</h1>
            <p>Know who you’re crossing paths with. Whether you and a friend are both travelling to the same place,
              or an old colleague is in town for the weekend.
            </p>
            <br>
            <p>Enable friends of friends, too, if you feel like meeting someone new who’s not a total stranger.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section class="section-2 container-fluid">
      <div class="d-flex text-center h-100 justify-content-center">
        <div class="my-auto align-middle w-100 text-center">
          <div class="container">
            <h1>trust me.</h1>
            <p>Land somewhere and open itchyfeet's map to see real recommendations by people you know in real life.</p>

            <p>No more tripadvisor. No more google searches at a foreign cafe with shitty wifi. Get out and explore.

            <p>Your best friend has been to Lisbon. She too appreciates a good coffee, so you know you can trust her.</p>

            <p>Her favourite spots are already on your itchyfeet map. Filter for cafes, or even specifically her recs.</p>

            <p>Then click a spot and find out exactly why she loves it, whether its her favourite order or the authentic atmosphere.</p>
          </div>
          <!-- <div class="row mb-5 mx-0 mx-md-3">
              <img class="seamless-section" src="/static/simple.png"/>
          </div> -->
        </div>
      </div>
    </section>

    <!-- <section class="section-3 container-fluid">
      <div class="d-flex text-center h-100 justify-content-center">
        <div class="my-auto align-middle w-100 text-center mx-3">
          <h1>Different.</h1>
          <div class="row mt-5 mb-5">
            <div class="col-lg-4 col-sm-12">
              <div class="img-wrapper">
                <img src="/static/different-section-2.jpg" />
              </div>
            </div>
            <div class="col-lg-4 col-sm-12">
              <div class="img-wrapper">
                <img src="/static/different-section-1.jpg" />
              </div>
            </div>
            <div class="col-lg-4 col-sm-12">
              <div class="img-wrapper">
                <img src="/static/different-section-3.jpg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section> -->

    <section class="section-4 container-fluid">
      <div class="container h-100">
        <div class="d-flex text-center h-100 justify-content-center">
          <div class="my-auto align-middle w-100">
            <h1>mums the word</h1>
            <div class="row mt-5">
              <div class="col-lg-6 col-sm-12 mb-5">
                <p>Don’t worry - Itchyfeet never shows your exact location, only what city you're in.</p>
              </div>
              <div class="col-lg-6 col-sm-12">
                <p>Enable ghost mode to get off the grid. Or easily edit your ‘blacklist’ to keep certain people out of the loop.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-5 container-fluid">
      <div class="container-fluid h-100">
        <div class="d-flex text-center h-100 justify-content-center">
          <div class="my-auto align-middle w-100 text-center">
            <h1>always feel like a local</h1>

            <div class="form-inline justify-content-center request-invite">
              <div class="form-group mr-1">
                <input type="email" class="form-control" placeholder="Your email" v-bind:value="email" v-on:keyup.enter="onRequestInviteClicked" v-on:change="onEmailUpdatedEvent"/>
              </div>

              <a class="btn" v-on:click="onRequestInviteClicked">Get early access</a>
            </div>
          </div>
        </div>
      </div>
    </section>
    <router-view />
  </div>
</template>

<script>
import {getWaitingListCount} from '../../api/'
import {TweenLite} from 'gsap'

export default {
  name: 'Home',
  props: ['email', 'setRequestInviteModalOpen', 'onEmailUpdated'],
  data: function () {
    return {
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      waitingListCountTween: 0,
      waitingListCount: false,
      waitingListCountLoading: false,
      waitingListCountError: false
    }
  },
  computed: {
    videoUrl: function () {
      return process.env.BG_VIDEO_URL
    }
  },
  mounted: function () {
    const {r: referrer} = this.$route.query
    if (referrer && referrer.length === 8) {
      window.localStorage.setItem('referrer', referrer)
    }

    if (this.waitingListCountLoading === false) {
      getWaitingListCount()
        .then(response => {
          console.log(response)
          this.waitingListCount = response.count
          this.waitingListCountLoading = false
          this.waitingListCountError = false
        })
        .catch(err => {
          this.waitingListCount = false
          this.waitingListCountLoading = false
          this.waitingListCountError = err
        })
    }

    TweenLite.to(this.$data, 3, {waitingListCountTween: 100})

    setTimeout(() => { this.show1 = true }, 500)
    setTimeout(() => { this.show2 = true }, 1250)
    setTimeout(() => { this.show3 = true }, 2000)
    setTimeout(() => { this.show4 = true }, 3000)
  },
  methods: {
    onEmailUpdatedEvent: function (e) {
      this.onEmailUpdated(e.target.value)
    },
    onRequestInviteClicked: function () {
      this.setRequestInviteModalOpen(true)
      this.$ua.trackEvent({
        eventCategory: 'Waiting List', eventAction: 'Click', eventLabel: 'Request Invite Opened', eventValue: 'Request Invite Opened'
      })
    },
    onCloseRequestInviteClicked: function () {
      this.setRequestInviteModalOpen(false)
      this.$ua.trackEvent({
        eventCategory: 'Waiting List', eventAction: 'Click', eventLabel: 'Request Invite Closed', eventValue: 'Request Invite Closed'
      })
    }
  },
  watch: {
    waitingListCount: function (newValue) {
      TweenLite.to(this.$data, 3, {waitingListCountTween: newValue})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/app";
  @import "../../styles/home";

  section img:not(.seamless-section):hover { transform: scale(1.1); }
  section img.seamless-section:hover { transform: scale(1.04); }

  .fade1-enter {
    opacity: 0;
  }

  .fade1-enter-active {
    transition: all 1s;
    animation: bounce-in 1s;
  }

  .fade1-enter-to {
    opacity: 1;
  }

  @keyframes bounce-in {
    0% {
      transform: scale(0.7);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/Home.vue